import "./index.css";

import Icon from "../Icon";

const Button = (props: ButtonProps) => {
  const { startIcon = null, endIcon = null } = props;
  const { onClick = null, disabled = false } = props;
  const { style = {} } = props;
  const { type = "white" } = props;

  const handleOnClick = () => {
    if (!disabled && onClick !== null) onClick();
  };

  const colorsIcons = {
    white: "black",
    transparent: "white",
    "panel-enabled": "#007CC3",
    "panel-disabled": "white",
  };

  return (
    <div
      onClick={handleOnClick}
      className={`base-button base-button-${type} ${
        onClick !== null ? "base-button-clickable" : ""
      }`}
      style={{ ...style }}
    >
      {startIcon !== null && (
        <Icon
          style={{ marginRight: "16px" }}
          type={startIcon}
          color={colorsIcons[type]}
        />
      )}
      {props.label || ""}
      {endIcon !== null && (
        <Icon
          style={{ marginLeft: "16px" }}
          type={endIcon}
          color={colorsIcons[type]}
        />
      )}
    </div>
  );
};

export default Button;
